import { useState, useCallback, useEffect } from "react";

/* -------------------- useToast Hook -------------------- */
export const useToast = (initial = "") => {
  const [toast, setToast] = useState(initial);
  const show = useCallback((text) => setToast(text), []);
  const hide = useCallback(() => setToast(""), []);
  return { toast, show, hide };
};

/* -------------------- AuroraGlassToast -------------------- */

const NeonToast = ({ text = "Saved to Photos", onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[9999] pointer-events-auto w-[90vw] max-w-md sm:max-w-lg">
      <div className="relative flex justify-center">
        {/* Glass Aurora Card */}
        <div className="relative flex items-center gap-4 rounded-3xl px-5 py-4
                        bg-gradient-to-br from-indigo-50/20 via-purple-50/20 to-pink-50/20
                        backdrop-blur-xl border border-white/10 shadow-xl
                        animate-popCard overflow-hidden">
          {/* Icon Bubble */}
<div className="relative flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full
                bg-gradient-to-tr from-indigo-400 to-purple-400 shadow-md border border-white/20">
  <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
</div>

          {/* Text */}
          <div className="flex flex-col min-w-0">
            <span className="font-semibold text-[#1a1a1a]  text-[13.2px] sm:text-sm truncate">{text}</span>
            <span className="text-xs text-[#1a1a1a] text-/70 mt-0.5">You can now close this page.</span>
          </div>

          {/* Close Button */}
          <button onClick={onClose} className="ml-3 p-1 rounded-lg hover:bg-white/10 transition">
            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M6 18L18 6" />
            </svg>
          </button>

          {/* Bloom Background */}
          <div className="absolute -top-16 -left-16 w-40 h-40 bg-indigo-400/20 blur-3xl rounded-full animate-bloom"></div>
          <div className="absolute -bottom-16 -right-16 w-40 h-40 bg-pink-400/20 blur-3xl rounded-full animate-bloom"></div>
        </div>
      </div>

      {/* Tailwind Keyframes */}
      <style>{`
        @keyframes popCard {
          0% { transform: translateY(-8px) scale(0.96); opacity: 0; }
          60% { transform: translateY(6px) scale(1.06); opacity: 1; }
          100% { transform: translateY(0) scale(1); opacity: 1; }
        }
        @keyframes bloom {
          0%, 100% { transform: scale(1); opacity: 0.6; }
          50% { transform: scale(1.1); opacity: 0.8; }
        }
        .animate-popCard { animation: popCard 0.36s cubic-bezier(.2,.9,.3,1); }
        .animate-bloom { animation: bloom 3s ease-in-out infinite; }
      `}</style>
    </div>
  );
};

export default NeonToast;
